import SimpleBar from 'simplebar';
let size = Math.round(innerHeight * 0.3160667251975417032484635645302897278)
document.querySelectorAll(".Modal__innerBlock").forEach((elm) => {
    new SimpleBar(elm, { autoHide: false, scrollbarMaxSize: size, scrollbarMinSize: size, });
})

